import React from 'react';

type MatchFallbackProps = {
    title: string;
    message: string;
    onBack: () => void;
};

export function MatchFallback({ title, message, onBack }: MatchFallbackProps) {
    return (
        <div className="min-h-screen bg-slate-100 px-4 py-12">
            <div className="mx-auto flex w-full max-w-sm flex-col items-center rounded-[32px] bg-white p-10 text-center shadow-2xl shadow-slate-900/10">
                <button
                    type="button"
                    onClick={onBack}
                    className="self-start rounded-full border border-slate-200 bg-white px-3 py-1 text-sm text-slate-500 shadow-sm"
                >
                    ←
                </button>
                <div className="mt-6 space-y-3">
                    <p className="text-base font-semibold text-slate-900">{title}</p>
                    <p className="text-sm leading-6 text-slate-500">{message}</p>
                </div>
                <button
                    type="button"
                    onClick={onBack}
                    className="mt-10 inline-flex items-center rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white"
                >
                    Back
                </button>
            </div>
        </div>
    );
}